/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

interface GlobalVar {
  NODE_ENV: string;
  BASE_URL: string;
  BASE_PATH: string;
  JUSTICE_API_URL: string;
  CLIENT_ID: string;
  CLIENT_REDIRECT_URI: string;
  JUSTICE_PUBLISHER_NAMESPACE: string;
  GOOGLE_TAG_MANAGER_ID: string;
  LEGAL_CDN_URL: string;
  STARBREEZE_ZENDESK_KEY: string;
  JUSTICE_DEFAULT_COUNTRY_CODE: string;
}

export const globalVar = ({
  ...process.env,
} as any) as GlobalVar;

export const isDevelopment = globalVar.NODE_ENV === "development";
export const isProduction = globalVar.NODE_ENV === "production";
